var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_585_2285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0005 32.4998H47.5005V27.4997C47.5005 21.9846 43.0154 17.4995 37.5003 17.4995C31.9852 17.4995 27.5001 21.9846 27.5001 27.4997V32.4998H25C23.62 32.4998 22.5 33.6198 22.5 34.9999V55.0002C22.5 56.3803 23.62 57.5003 25 57.5003H50.0005C51.3806 57.5003 52.5006 56.3803 52.5006 55.0002V34.9999C52.5006 33.6198 51.3806 32.4998 50.0005 32.4998ZM42.5004 32.4998H32.5002V27.4997C32.5002 24.7447 34.7452 22.4996 37.5003 22.4996C40.2553 22.4996 42.5004 24.7447 42.5004 27.4997V32.4998Z",
    fill: "url(#paint0_linear_585_2285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4315 25.1797C77.1565 24.6697 75.6965 25.2897 75.1865 26.5747L73.6914 30.3148C69.4014 14.3195 54.8261 2.49927 37.5007 2.49927C16.8203 2.49927 0 19.3196 0 40C0 60.6804 16.8203 77.5007 37.5007 77.5007C47.5159 77.5007 56.9361 73.6007 64.0213 66.5205C64.9963 65.5455 64.9963 63.9605 64.0213 62.9855C63.0462 62.0104 61.4612 62.0104 60.4862 62.9855C54.3411 69.1206 46.1809 72.5006 37.5007 72.5006C19.5804 72.5006 5.0001 57.9204 5.0001 40C5.0001 22.0796 19.5804 7.49937 37.5007 7.49937C53.106 7.49937 66.1713 18.5596 69.2864 33.2499L64.2713 28.2298C63.2962 27.2548 61.7112 27.2548 60.7362 28.2298C59.7612 29.2048 59.7612 30.7898 60.7362 31.7648L70.7364 41.765C71.2064 42.245 71.8464 42.5 72.5014 42.5C72.6664 42.5 72.8364 42.485 73.0064 42.45C73.8315 42.28 74.5115 41.71 74.8215 40.93L79.8216 28.4298C80.3316 27.1448 79.7116 25.6897 78.4315 25.1797Z",
    fill: "url(#paint1_linear_585_2285)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_585_2285",
    x1: 37.5003,
    y1: 17.4994,
    x2: 37.5003,
    y2: 57.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2020FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_585_2285",
    x1: 40,
    y1: 2.49908,
    x2: 40,
    y2: 77.4992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2020FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_585_2285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordReset);
export default __webpack_public_path__ + "static/media/password_reset.b9337db2237bdeb0fe0ebbff8dcd736f.svg";
export { ForwardRef as ReactComponent };